import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFastForward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"fast-forward"} maskId="square-filled-radius-0-stroke-1-IconFastForward"><path d="M4 4.01074V19.9897L12 14.095V19.9897L22.8429 12.0002L12 4.01074V9.90548L4 4.01074Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFastForward;
